module.exports = __webpack_public_path__ + "static/media/correopassword.266ab07b.svg";